module.exports = __webpack_public_path__ + "img/home-footer.a99cb769.png";